import React, { useEffect, useState } from "react";
import TableComp from "src/components/shared/table/TableComp";
import useOrderBody from "../utils/useOrderBody";
import { Box, Button, Stack } from "@mui/material";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import useAppGlobal from "src/context/useAppGlobal";
import useQueryParams from "src/hooks/useQueryParams";
import { COMMOM_STATUS, ORDER_SOUCE_TYPE, orderStatusFormatted } from "src/constant";
import OrderChildTabExchange from "./OrderChildTabExchange";
import useOrderConfirmAllTS from "src/hooks/orders/useOrderConfirmAllTS";
import { enqueueSnackbar } from "notistack";
import OrderDeliveringConfirmAll from "./OrderDeliveringConfirmAll";
import OrderFilter from "../components/OrderFilter";
import useCountOrderTabs from "src/hooks/orders/useCountOrderTabs";
import useResetParamsOnTabChange from "src/hooks/useResetParamsOnTabChange";

const topbarSearchList = [
  {
    id: 1,
    title: "Đơn hàng",
    value: "code",
  },
  {
    id: 2,
    title: "Khách hàng",
    value: "customer",
  },
  {
    id: 3,
    title: "Nhân viên",
    value: "sales",
  },
  {
    id: 4,
    title: "Số serial sản phẩm",
    value: "itemCode",
  },
  {
    id: 5,
    title: "Mã vận chuyển",
    value: "shippingCode",
  },
];
const sources = [
  { id: orderStatusFormatted.all, title: "Tất cả" },
  { id: orderStatusFormatted.Returning, title: "Đang trả hàng" },
  { id: orderStatusFormatted.ReturnedWaitToCheck, title: "Kiểm tra hàng" },
  { id: orderStatusFormatted.Returned, title: "Trả hàng thành công" },
  { id: orderStatusFormatted.ReturnFailed, title: "Trả hàng thất bại" },
  { id: orderStatusFormatted.Canceled, title: "Hủy trả hàng" },
  { id: orderStatusFormatted.Lost, title: "Thất lạc" },
];
const ORDER_STATUS = {
  Manual: "Return",
  Exchange: "Exchange",
  DeliveredFailed: "DeliveredFailed",
};

export default function AllOrderTable({ warehouseId, mutate }) {
  const [option, setOption] = useQueryParams();
  const { handleOpenDialog } = useAppGlobal();
  const [keyWord, setKeyWord] = useState();
  const [searchBy, setSearchBy] = useState();
  const [orderIds, setOrderIds] = useState([]);
  const [paramsQuery, setParamsQuery] = useState({
    source: (ORDER_SOUCE_TYPE[option?.tab] ?? option?.source === COMMOM_STATUS.None) ? undefined : option?.source,
    shoppingProvider: undefined,
  });

  useResetParamsOnTabChange(option?.tab, setParamsQuery, () => ({
    source: (ORDER_SOUCE_TYPE[option?.tab] ?? option?.source === COMMOM_STATUS.None) ? undefined : option?.source,
    shoppingProvider: undefined,
  }));

  const { header, sortData, bodyList, pagi, setPagi, total } = useOrderBody({
    warehouseId,
    setOrderIds,
    orderIds,
    paramsQuery,
    keyWord,
    searchBy,
    topbarSearchList,
    mutate,
  });
  const { trigger: confirmAll } = useOrderConfirmAllTS();
  const { data: counts } = useCountOrderTabs({
    warehouse: warehouseId,
    tab: ORDER_STATUS[option?.tab],
  });

  const handleChildTab = (name) => {
    setOption({
      ...option,
      childTab: name === orderStatusFormatted.AllReturn ? undefined : name,
    });
  };

  const handleConfirmAll = async () => {
    const res = await confirmAll({
      body: {
        orderIds: orderIds,
        trackingStatus: orderStatusFormatted.Delivering,
        warehouse: warehouseId,
      },
    });
    if (res?.success) {
      setOrderIds([]);
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? "Lỗi khi xác nhận hàng loạt", { variant: "error" });
    }
  };

  const handleConfirmDelivering = () => {
    handleOpenDialog({
      title: "Xác nhận trạng thái đơn hàng hàng loạt",
      content: (
        <OrderDeliveringConfirmAll
          orderIds={orderIds}
          whouseId={warehouseId}
        />
      ),
      size: "sm",
    });
  };

  useEffect(() => {
    setOption({ ...option, total: total });
  }, [total]);

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        my={1.5}
      >
        <Box
          display="flex"
          gap="6px"
          alignItems="flex-start"
        >
          <SearchFilterComp
            selectList={topbarSearchList}
            getSearchKeyword={setKeyWord}
            getSelectKeyword={setSearchBy}
            autoComplete={{
              customer: {
                endpoint: "/api/v1/customers",
                searchField: "fullName",
                state: setKeyWord,
                label: "Khách hàng",
              },
              sales: {
                type: "Sales",
                endpoint: "/api/v1/users",
                state: setKeyWord,
                label: "Nhân viên",
              },
            }}
          />
        </Box>
        <Stack
          direction="row"
          gap="6px"
        >
          {[orderStatusFormatted.ReadyToPick, orderStatusFormatted.Delivering]?.includes(option?.tab) && (
            <Button
              disabled={!orderIds?.length}
              onClick={option?.tab === orderStatusFormatted.ReadyToPick ? handleConfirmAll : handleConfirmDelivering}
              variant="contained"
              sx={{ height: "100%", maxHeight: "36.5px" }}
              size="small"
            >
              Xác nhận hàng loạt
            </Button>
          )}
          {/* ADVENCE FILTER */}
          <OrderFilter
            setParamsQuery={setParamsQuery}
            paramsQuery={paramsQuery}
          />
        </Stack>
      </Stack>
      {/* CHILD TAB */}
      {[orderStatusFormatted.Manual, orderStatusFormatted.ReturnRefund]?.includes(option?.tab) && (
        <Box sx={{ display: "flex", gap: "6px", flexWrap: "wrap", mb: "12px" }}>
          <Button
            sx={{
              borderRadius: "100px",
              p: "4px 8px",

              background: [orderStatusFormatted.Returning]?.includes(option?.childTab) ? "var(--grey)" : "transparent",
            }}
            onClick={() => handleChildTab(orderStatusFormatted.Returning)}
          >
            Đang trả hàng ({counts?.data[orderStatusFormatted.Returning]})
          </Button>
          <Button
            onClick={() => handleChildTab(orderStatusFormatted.ReturnedWaitToCheck)}
            sx={{
              borderRadius: "100px",
              p: "4px 8px",

              background: option?.childTab === orderStatusFormatted.ReturnedWaitToCheck ? "var(--grey)" : "transparent",
            }}
          >
            Đã trả hàng chờ kiểm tra ({counts?.data[orderStatusFormatted.ReturnedWaitToCheck]})
          </Button>
          <Button
            onClick={() => handleChildTab(orderStatusFormatted.Returned)}
            sx={{
              p: "4px 8px",

              borderRadius: "100px",
              background: option?.childTab === orderStatusFormatted.Returned ? "var(--grey)" : "transparent",
            }}
          >
            Trả hàng thành công ({counts?.data[orderStatusFormatted.Delivered]})
          </Button>
          <Button
            onClick={() => handleChildTab(orderStatusFormatted.ReturnFailed)}
            sx={{
              p: "4px 8px",
              borderRadius: "100px",
              background: option?.childTab === orderStatusFormatted.ReturnFailed ? "var(--grey)" : "transparent",
            }}
          >
            Trả hàng thất bại ({counts?.data[orderStatusFormatted.DeliveredFailed]})
          </Button>
        </Box>
      )}
      {/* CHILD TAB FOR DELIVERY FAILED */}
      {orderStatusFormatted.DeliveredFailed === option?.tab && (
        <Box
          mb="12px"
          display="flex"
          gap="12px"
        >
          {sources?.map((v) => {
            return (
              <Button
                key={v?.id}
                sx={{
                  borderRadius: "100px",
                  p: "4px 8px",

                  background: option?.childTab === v?.id ? "var(--grey)" : "transparent",
                }}
                onClick={() => setOption({ ...option, childTab: v?.id })}
              >
                {v?.title} {counts?.data[v?.id] ? ` (${counts?.data[v?.id]})` : ""}
              </Button>
            );
          })}
        </Box>
      )}
      {orderStatusFormatted.Exchange === option.tab && <OrderChildTabExchange warehouseId={warehouseId} />}

      {/* DATA */}
      <TableComp
        setPagi={setPagi}
        pagi={pagi}
        headers={header}
        sortData={sortData}
        bodyList={bodyList ?? []}
      />
    </>
  );
}
